import * as types from './action-types';

export function popupShow(type, data = {}) {
  return {
    type: types.POPUP_SHOW,
    popupType: type,
    data,
  };
}

export function popupHide(data = {}) {
  return {
    type: types.POPUP_HIDE,
    data
  };
}


export function popupToggle(type, data) {
  return (dispatch, getState) => {
    const state = getState();

    if (state.popup.type !== type) {
      return dispatch(popupShow(type, data));
    } else {
      return dispatch(popupHide(data));
    }
  };
}



// WEBPACK FOOTER //
// ./actions/popup.js